import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, reduxForm, change } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, FormGroup, Col, Panel } from 'react-bootstrap';

import Uploader from './Uploader';
import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';
import InputFieldComponent from '../../Common/FormField/InputFieldComponent';
import Link from '../../Link';

import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';

import s from './AddPopularLocationManagement.css';
import bt from '../../../components/commonStyle.css';
class AddPopularLocationManagement extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    formatMessage: PropTypes.func,
    initialValues: PropTypes.object,
  };

  onSuggestSelect = (data, value) => {
    const { change } = this.props;
    if (value) {
      change('locationAddress', value);
    }
  }

  onTextChange = (value) => {
    const { change } = this.props;
    if (value !== undefined && value?.trim() === '') {
      change('locationAddress', value);
    }
  }

  renderPlacesSuggest = ({ input, label, meta: { touched, error }, className, placeholder }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={bt.space4}>
        <label className={cx(bt.commonLabelText)}>{label}</label>
        <PlaceGeoSuggest
          {...input}
          placeholder={placeholder}
          className={cx(bt.commonControlInput, s.popularLocationGeoSuggestion, 'newGeoSuggestInput')}
          onSuggestSelect={this.onSuggestSelect}
          onChange={this.onTextChange}
          id={'addPopular'}
          containerClass='siteAdminPopularGeoSuggest'
          hideSeeAll={true}
        />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </FormGroup>
    )
  }

  render() {
    const { error, handleSubmit, submitting } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx('addpopular-autocomplete', 'popularLocationContainer')}>
        <h1 className={s.siteAdminHeading}><FormattedMessage {...messages.addPopularLocation} /></h1>
        <Col xs={12} sm={12} md={9} lg={8} className={s.blockCenter}>
          <div className={cx(s.space4, 'singleButtonFlexEnd')}>
            <Link to={'/siteadmin/popularlocation'} className={cx(bt.btnPrimaryBorder, bt.btnLarge, bt.noTextDecoration)}>
              <FormattedMessage {...messages.goBack} />
            </Link>
          </div>
          <Panel className={cx(s.panelHeader, s.mobilePadding)}>
            <form onSubmit={handleSubmit(submit)}>
              {error && <strong>{formatMessage(error)}</strong>}
              <FormGroup className={bt.space4}>
                <label className={s.labelTextNew} ><FormattedMessage {...messages.imageLabel} /></label>
                <Uploader />
              </FormGroup>

              <Field name="location"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.location)}
                inputClass={bt.commonControlInput}
                formGroupClass={bt.space4}
                placeholder={formatMessage(messages.locationPlaceHolder)}
              />

              <Field
                name="locationAddress" type="text"
                component={this.renderPlacesSuggest}
                label={formatMessage(messages.locationAddress)}
                placeholder={formatMessage(messages.locationAddressPlaceHolder)}
              />
              <div className='singleButtonFlexEnd'>
                <Button className={cx(bt.button, bt.btnPrimary, bt.btnlarge)} type="submit" disabled={submitting} >
                  <FormattedMessage {...messages.save} />
                </Button>
              </div>
            </form>
          </Panel>
        </Col>
      </div>
    );
  }
}

AddPopularLocationManagement = reduxForm({
  form: 'AddPopularLocation', // a unique name for this form
  validate
})(AddPopularLocationManagement);

const mapState = (state) => ({});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AddPopularLocationManagement)));